var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.icon],attrs:{"viewBox":_vm.viewBox,"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#icon-' + _vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }